import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {fetchProfileSelf} from "../../../profile/services/fetchProfileSelf/fetchProfileSelf";
import {setToken} from "../tokenManagement/tokenManagement";
import {snackbarAction} from "../../../errors/SnackbarSlice";

interface ILoginResponse {
    email: string
    password: string
    language: 'ru' | 'en' | 'pl'
}

export const fetchAuthLogin = createAsyncThunk<void,
    ILoginResponse, ThunkConfig<string>>(
        'auth/fetchAuthLogin',
        async (authData, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            try {
                const response = await extra.api.post(
                    `/auth/login`,
                    authData);
                if (!response.data.success) {

                    return rejectWithValue(response.data.codeKey)
                }
                if (response.data.success) {
                    await setToken("access-token")
                    dispatch(fetchProfileSelf("access-token"))
                }
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                console.log('err', err)
                // @ts-ignore
                return rejectWithValue(err.data.error);
            }
        },
    );
